import { makeAutoObservable, runInAction } from "mobx";
import { IStoreRole } from "../../../models/User";
import RoleService, { IStoreRolesWithPermissionsResponse } from "../../../services/api/role-service";
import { rootContainer, TYPE } from "../../../services/container/root";

/** C-RMA special roles to manage modes */
export const C_RMA_ROLES = {
    RMA_CREATION_MODE_GOD: 'RMA Creation Mode: God',
    RMA_CREATION_MODE_POLICY_LED: 'RMA Creation Mode: Policy Led',
};

export class RolesListStore {
    /** publicly available roles, can be selected from selector */
    private _storeRoles: IStoreRole[] = [];
    private _cRmaRoles: IStoreRole[] = [];

    private _permissions: { [key: number]: string; }[] = [];
    private _isLoading: boolean = false;

    private get service(): RoleService {
        return rootContainer.get<RoleService>(TYPE.RoleService);
    }

    constructor() {
        makeAutoObservable(this);
    }

    public get isLoading(): boolean {
        return this._isLoading;
    }

    public get storeRoles(): IStoreRole[] {
        return this._storeRoles;
    }

    public get cRmaRoles(): IStoreRole[] {
        return this._cRmaRoles;
    }

    public getPermissionName(id: number) {
        return this._permissions[id];
    }

    public async load(): Promise<void> {
        this._isLoading = true;
        let res:IStoreRolesWithPermissionsResponse;

        try {
            res = await this.service.loadStoreRolesWithPermissions();
        }
        catch {}

        runInAction(() => {
            if (res) {
                this._permissions = res.permissions;
                /** splitting received roles into 2 lists */
                const cRmaRoles = Object.values(C_RMA_ROLES);
                this._cRmaRoles = (res.roles ?? []).filter(r => cRmaRoles.includes(r.name));
                this._storeRoles = (res.roles ?? []).filter(r => !cRmaRoles.includes(r.name));
            }
            this._isLoading = false;
        });
    }

}

export default new RolesListStore();
